import { ChangeDetectionStrategy, Component, inject, Input, ViewContainerRef } from '@angular/core';

import { ButtonComponent, EmptyStateComponent, IconComponent } from '@core/user-interface-legacy';
import type { ViewEmptyState } from '@core/views-types';

@Component({
  selector: 'rt-views-empty-state',
  imports: [EmptyStateComponent, ButtonComponent, IconComponent],
  templateUrl: './views-empty-state.component.html',
  styleUrls: ['./views-empty-state.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewsEmptyStateComponent {
  @Input({ required: true }) public defaultEmptyState: ViewEmptyState;
  @Input({ required: true }) public filteredEmptyState: ViewEmptyState;
  @Input() public customEmptyState: ViewEmptyState | null;

  @Input({ required: true }) public isViewPredefined: boolean;
  @Input({ required: true }) public filtersChanged: boolean;
  @Input({ required: true }) public filtersApplied: boolean;

  public emptyState: ViewEmptyState;
  public vcRef = inject(ViewContainerRef);

  public ngOnChanges() {
    this.emptyState = this.chooseEmptyState();
  }

  private chooseEmptyState(): ViewEmptyState {
    switch (true) {
      case this.filtersApplied && !this.isViewPredefined:
        return this.filteredEmptyState;

      case this.isViewPredefined && this.filtersChanged:
        return this.filteredEmptyState;

      default:
        return this.customEmptyState || this.defaultEmptyState;
    }
  }
}
